const useSelector = (element: any, isMobile = false) => {
    const openCssName = "open";
    const eventName = "click";
    const _useObserver = false;

    const getElement = (e: any) => {
        const el = element.current as HTMLSpanElement;
        return el ?? e.target?.parentElement;
    }

    const listener = (e: any) => {
        const $span = getElement(e);

        if (!$span) {
            return;
        }

        const target = e?.target;
        const isChild = target && $span.contains(e?.target);

        if (isChild) {
            return;
        }

        $span.classList.remove(openCssName);

        document.body.removeEventListener(eventName, listener);
    }

    const removeEventListener = () => document.body.removeEventListener(eventName, listener);

    const addEventListener = () => document.body.addEventListener(eventName, listener);

    //Note, when the inverted dropdown is displayed, there is a moment where it's not inverted & then it is
    //which looks weird. Adding extra css - e.g default opacity of 0 & then change to 1 - sorts of works 
    //but sometimes it appears invered, disappears & then appears inverted again
    const addObserver = ($span: HTMLElement) => {
        const options = {
            threshold: [1]
        };

        const dropdown = $span.querySelector("div") as HTMLDivElement;
        let observer: IntersectionObserver;

        const callback: IntersectionObserverCallback = (entries, observer) => {
            entries.forEach((entry) => {
                let invert = false;

                if (entry.intersectionRatio !== 1) {
                    invert = entry.boundingClientRect.top > entry.boundingClientRect.height;
                }

                const height = (dropdown?.clientHeight ?? 0) + 10;
                const alreadyInverted = dropdown?.style.top?.startsWith("-") ?? false;// $span.className.includes("inverted");
                //$span.classList.toggle("inverted-" + height, invert);

                dropdown.style.top = invert ? `-${height}px` : ``;

                const timeout = !alreadyInverted && invert ? 200 : 0;
                setTimeout(() => $span.classList.add("visible"), timeout);

                if (invert) {
                    observer.disconnect();
                }
            });
        }

        // eslint-disable-next-line prefer-const
        observer = new IntersectionObserver(callback, options);

        if (dropdown) {
            observer.observe(dropdown);
        }
    }

    const toggleIsOpen = (e: any) => {
        const $span = getElement(e);

        if (!$span) {
            return;
        }

        const isOpen = $span.className.includes(openCssName);

        if ((e?.forceOpen ?? false) && isOpen) {
            return;
        }

        e?.preventDefault();
        e?.stopPropagation();

        const newValue = !isOpen;

        if (!newValue) {
            $span.classList.remove(openCssName);
            $span.classList.remove("visible");
            removeEventListener();
            return;
        }

        $span.classList.add(openCssName);

        if (_useObserver) {
            addObserver($span);
            addEventListener();
            return;
        }

        const clientRect = $span.getBoundingClientRect();

        const y = clientRect?.y ?? 0;

        const screenHeight = window.innerHeight;

        const $div = $span.querySelector("div") as HTMLDivElement;

        const optionsHeight = $div?.clientHeight ?? 0;

        const screenHeightNeeded = (clientRect?.bottom ?? 0) + optionsHeight + 10;

        const needToFlip = (optionsHeight < y) && (screenHeightNeeded > screenHeight);

        $div.style.top = needToFlip ? `-${optionsHeight + 20}px` : "";


        if (isMobile) {
            const margin = 0 - (($div.clientWidth - $span.clientWidth) / 2);
            $div.style.marginLeft = `${margin}px`;
        }

        // $span.classList.toggle("inverted-" + optionsHeight, needToFlip);

        addEventListener();
    }

    // const $span = element.current as HTMLSpanElement;
    // const isOpen = $span && $span.className.includes(openCssName);
    const cssClassName = "select";// + (isOpen ? ` ${openCssName}` : "");

    return {
        toggleIsOpen, cssClassName
    };
}

export default useSelector;